import select from '../assets/icons/select.png'
import automate from '../assets/icons/automate.png'
import rocket from '../assets/icons/rocket2.png'

const data = [
    {
        id: 1,
        img: select,
        title: 'Select',
        para: 'Let us help you detect time-consuming business processes ideally suited for RPA that continue to be done by humans.'
    },
    {
        id: 1,
        img: automate,
        title: 'Automate',
        para: 'We will provide you with RPA solutions that minimize the involvement of human employees in repetitive tasks. This will channel their attention back to purposeful activities.'
    },
    {
        id: 1,
        img: rocket,
        title: 'Enjoy',
        para: 'Use the reclaimed human potential, time and resources to craft a new future for your business. We will support you at each stage of the change management process to facilitate the deployment of RPA.'
    },
]

export default data;